/**
 * Which dialer a rep last chose: the keypad, or the power queue.
 *
 * Kept out of the components because it is the one part of the toggle with real
 * failure modes. `localStorage` is not always there and not always readable:
 * vitest runs in node with no DOM at all, a private window can clear it between
 * loads, and a browser set to block site data makes the ACCESSOR ITSELF throw
 * rather than returning null. An uncaught throw here would take the whole dialer
 * down over a remembered preference, so every read and write is guarded and the
 * failure path is simply "simple mode".
 */

export type DialerMode = 'simple' | 'power';

export const DIALER_MODE_KEY = 'limephone.dialerMode';

export function coerceDialerMode(value: unknown): DialerMode {
  return value === 'power' ? 'power' : 'simple';
}

export function readDialerMode(): DialerMode {
  try {
    return coerceDialerMode(globalThis.localStorage?.getItem(DIALER_MODE_KEY));
  } catch {
    return 'simple';
  }
}

export function writeDialerMode(mode: DialerMode): void {
  try {
    globalThis.localStorage?.setItem(DIALER_MODE_KEY, coerceDialerMode(mode));
  } catch {
    // A remembered preference is not worth an exception.
  }
}
